<template>
    <div>
        
        <div class="btn-pointer">
            <slick ref="slick" class="slider-fullwidth" :options="slickOptions" v-if="data && data.slides">
                
                <b-card v-for="(d, i) in data.slides" class="slider-full border-0 radius-0" :key="i" @click="clicked(d)" v-if="d.imagem"
                    overlay
                    :img-src="d.imagem.url" 
                    :img-alt="d.titulo"
                    text-variant="white"
                >
                    <div class="container h-100 d-block d-sm-flex slider-home" @click="goTo(d.link)">
                        <div class="row justify-content-center align-self-center mt-0 mt-lg-5" v-if="d.titulo">
                            <div class="col-12 col-sm-10 col-md-10 col-lg-8 text-center">
                                <h1 class="text-lowercase extra-bold mt-0 mt-md-2">
                                    <h1 class=" font-glacial-bold text-lowercase">
                                        {{d.titulo}}
                                    </h1>
                                </h1>

                                <p class="d-none d-sm-block mt-0 pt-0 mt-md-4 pt-md-2 font-glacial-regular">
                                    {{d.descricao}}
                                </p>
                                <!-- <button class="btn-curso btn font-glacial-bold" :href="d.link">Mais sobre o curso</button> -->
                            </div>
                        </div>
                    </div>
                </b-card>
            </slick>
        </div>

    </div>
</template>

<script>

export default {
    props: {
        data: null
    },

    data() {
        return {
            slickOptions: {
                slidesToShow: 1,
                dots:true,
                arrows:true// Any other options that can be got from plugin documentation
            },
        };
    },

    // All slick methods can be used too, example here
    methods: {
        clicked(data){
            if (data.link){
                if(data.link.includes('http:')){
                    window.open(data.link)
                } else {
                    window.location.replace(data.link)
                }
            } else {
                if(data.video){
                    this.$store.commit('setVideoId', data.video)
                    this.$root.$emit('bv::show::modal','video-modal')
                }
            }
        },

        next() {
            this.$refs.slick.next();
        },

        prev() {
            this.$refs.slick.prev();
        },

        reInit() {
            // Helpful if you have to deal with v-for to update dynamic lists
            this.$nextTick(() => {
                this.$refs.slick.reSlick();
            });
        },

        // Events listeners
        handleAfterChange(event, slick, currentSlide) {
            console.log('handleAfterChange', event, slick, currentSlide);
        },
        handleBeforeChange(event, slick, currentSlide, nextSlide) {
            console.log('handleBeforeChange', event, slick, currentSlide, nextSlide);
        },
        handleBreakpoint(event, slick, breakpoint) {
            console.log('handleBreakpoint', event, slick, breakpoint);
        },
        handleDestroy(event, slick) {
            console.log('handleDestroy', event, slick);
        },
        handleEdge(event, slick, direction) {
            console.log('handleEdge', event, slick, direction);
        },
        handleInit(event, slick) {
            console.log('handleInit', event, slick);
        },
        handleReInit(event, slick) {
            console.log('handleReInit', event, slick);
        },
        handleSetPosition(event, slick) {
            console.log('handleSetPosition', event, slick);
        },
        handleSwipe(event, slick, direction) {
            console.log('handleSwipe', event, slick, direction);
        },
        handleLazyLoaded(event, slick, image, imageSource) {
            console.log('handleLazyLoaded', event, slick, image, imageSource);
        },
        handleLazeLoadError(event, slick, image, imageSource) {
            console.log('handleLazeLoadError', event, slick, image, imageSource);
        },
    }
}    
</script>
<style>
.card-img{
    height:auto !important;
}
</style>




// WEBPACK FOOTER //
// src/components/widgets/slider-fullwidth.vue